import { useSelector } from 'react-redux'
import { useFirestoreConnect } from 'react-redux-firebase'
import { WORKFLOW_COLLECTION } from '../../modules/firebase/collections'
import { workflow } from '../../modules/ui/workflow'

export function useWorkflow() {
    useFirestoreConnect([{ collection: WORKFLOW_COLLECTION }])
    const doc = useSelector( ({ firestore: { data } }) => data[WORKFLOW_COLLECTION] && data[WORKFLOW_COLLECTION][workflow])

    // getNextStep: id => { doc.steps.find((step, idx, arr) => {
    // 		return idx > 0 && arr[idx-1].id === id || idx == arr.length-1
    // 	}) },
    return doc
}
